function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEasypanelLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "easypanel_svg__a",
    x1: 395.338,
    x2: 116.737,
    y1: 293.742,
    y2: 776.302,
    gradientTransform: "translate(0 -279)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#12cd87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#12abcd"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M507.8 232.6c5.6-9.7 5.6-21.7 0-31.5l-101-174.9c-5.6-9.7-16-15.7-27.3-15.7H177.7c-11.3 0-21.7 6-27.3 15.7L85.3 139l-81 140.4c-5.6 9.7-5.6 21.7 0 31.5l100.9 174.9c5.6 9.7 16 15.7 27.3 15.7h201.9c11.3 0 21.7-6 27.3-15.7l65-112.8zM426.7 373l6.8-11.9c5.6-9.7 5.6-21.7 0-31.5L332.6 154.8c-5.6-9.8-16-15.8-27.3-15.7h-220L78.5 151c-5.6 9.7-5.6 21.7 0 31.5l100.9 174.8c5.6 9.8 16 15.8 27.3 15.7z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#easypanel_svg__a)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEasypanelLogo);
export default __webpack_public_path__ + "static/media/easypanel-logo.da385d8257a7996f59a74222fe2b029d.svg";
export { ForwardRef as ReactComponent };